import { signOut, useSession } from 'next-auth/react';
import { useRouter } from 'next/navigation';
import { useState } from 'react';

import Icon from '@/components/common/Icon';

import Modal from './Modal';
import UserLogin from './UserLogin';

type UserToolsProps = {};

const UserTools = ({}: UserToolsProps) => {
  const { data: session, status } = useSession();
  const [isOpen, setIsOpen] = useState(false);
  const router = useRouter();

  const onClose = () => {
    setIsOpen(false);
  };

  const onOpen = () => {
    setIsOpen(true);
  };

  const handleLogout = async () => {
    await signOut({ callbackUrl: '/' });
  };

  if (status === 'loading') {
    return (
      <div className="flex items-center justify-center">
        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (session) {
    return (
      <div className="flex flex-row flex-nowrap items-center md:gap-15 gap-10">
        <div>
          <button type="button" onClick={() => router.push('/account/profile')} className="flex items-center justify-center cursor-pointer  text-gray-800 hover:text-gray-400" title="Cuenta">
            <Icon name="user" size={20} style="regular" />
          </button>
        </div>
        <div>
          <button type="button" onClick={handleLogout} className="flex items-center justify-center cursor-pointer  text-gray-800 hover:text-gray-400" title="Cerrar sesión">
            <Icon name="logout" size={20} />
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      <div>
        <button type="button" onClick={onOpen} className="flex items-center justify-center text-gray-800 hover:text-gray-400 cursor-pointer" title="Iniciar sesión">
          <Icon name="user" size={20} style="regular" />
        </button>
      </div>
      {isOpen && (
        <Modal visible={isOpen} show={onOpen} close={onClose}>
          <UserLogin />
        </Modal>
      )}
    </>
  );
};

export default UserTools;
